const $ = require('jquery');
const initInfluencerShareLink = require('modules/influencer-share-link')

const BANNER_TARGET_CLASS = '.js-cpl-banner';
const ITEM_CLASS = '.card--cfy';
const ACTIVE_CLASS = 'card-cfy--active';
const CPL_ID_PARAM = 'cplid';

$(function() {
  initInfluencerShareLink();

  const urlParams = new URLSearchParams(window.location.search);
  const cplId = urlParams.get(CPL_ID_PARAM);

  $(ITEM_CLASS, $(BANNER_TARGET_CLASS)).each((i, el) => {
    const $card = $(el);
    const $anchor = $('a', $card);

    if ($anchor.length) {
      const href = $anchor.attr('href');
      const hrefParts = href ? href.split('?') : [];
      const anchorUrlParams = new URLSearchParams(hrefParts.length === 2 ? '?' + hrefParts[1]  : '');
      const anchorCplId = anchorUrlParams.get(CPL_ID_PARAM);

      if (anchorCplId === cplId) {
        $card.addClass(ACTIVE_CLASS);
      }
    }
  });
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/cpl/index.js